import { HubTableRoot } from "./hub-table";
import { HubTableColumn } from "./parts/view-column";
import { HubTableEmpty } from "./parts/view-empty";
import { HubTableErrorMessage } from "./parts/view-error-message";
import { HubTableForbidden } from "./parts/view-forbidden";
import { HubTableLoading } from "./parts/view-loading";

export type * from "./types-hub-table";

/**
 * Tabela das listagens (`HubTable.Root/Column/Empty/Loading/Error/Forbidden`) sobre o `DataTable` do Prime: lazy,
 * ordenação no cabeçalho, paginador do Hub, densidade e colunas das configurações, os estados da lista e a calha de
 * rolagem fora da moldura.
 */
export const HubTable = {
  Root: HubTableRoot,
  Column: HubTableColumn,
  Empty: HubTableEmpty,
  Loading: HubTableLoading,
  Error: HubTableErrorMessage,
  Forbidden: HubTableForbidden,
};
